module.exports = __webpack_public_path__ + "static/media/document_upload.6b884697.svg";